import type { Meta, StoryObj } from "@storybook/react";

import { TotalOnboardingSteps } from "@/constants/Onboarding";
import type { OnboardingProgressCardProps } from "@/ui/components/onboarding/v2/cards/OnboardingProgressCard";
import { OnboardingProgressCard } from "@/ui/components/onboarding/v2/cards/OnboardingProgressCard";
import { Box } from "@/ui/layout";
import { LayoutToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<OnboardingProgressCardProps> = {
  title: "Components/Onboarding/Cards/Onboarding Progress Card",
  component: OnboardingProgressCard,
  args: {
    currentStepIndex: 0,
    testID: "story",
    totalSteps: TotalOnboardingSteps,
  },
  argTypes: {
    currentStepIndex: {
      control: {
        max: TotalOnboardingSteps - 1,
        min: 0,
        step: 1,
        type: "range",
      },
    },
    patientName: {
      control: "text",
    },
  },
  render: (args) => (
    <Box paddingHorizontal={LayoutToken.ContentPaddingHorizontal} width="100%">
      <OnboardingProgressCard {...args} />
    </Box>
  ),
};

type Story = StoryObj<OnboardingProgressCardProps>;

const EarlyProgress: Story = {
  args: {
    currentStepIndex: 0,
  },
};

const MidProgress: Story = {
  args: {
    currentStepIndex: 2,
  },
};

const Complete: Story = {
  args: {
    currentStepIndex: TotalOnboardingSteps - 1,
  },
};

const ProxyView: Story = {
  args: {
    currentStepIndex: 1,
    patientName: "Renee",
  },
};

export { Complete, EarlyProgress, MidProgress, ProxyView };
export default StoryMeta;
